import React from "react";
import { Link } from "react-router-dom";
import { ouvrirPreferences } from "../utils/consent";

/**
 * Pied de page réduit des pages d'atterrissage.
 *
 * Réduit, mais pas supprimé : les mentions légales et la politique de
 * confidentialité doivent rester accessibles depuis toute page qui collecte
 * des données (LCEN et RGPD), et Google Ads refuse les pages de destination
 * qui n'exposent pas ces informations. Le lien vers les préférences cookies
 * est requis pour la même raison que sur le reste du site.
 */
const PiedLanding = () => (
  <footer className="bg-gray-900 text-gray-300 py-10 mt-16">
    <div className="container mx-auto px-4">
      <div className="max-w-4xl mx-auto text-center space-y-4">
        <p className="text-white font-semibold">Transition Énergie France</p>
        <p className="text-sm">
          Assistant à maîtrise d&apos;ouvrage agréé ANAH pour MaPrimeAdapt&apos; —
          Paris, Seine-et-Marne, Essonne, Hauts-de-Seine, Seine-Saint-Denis, Val-d&apos;Oise.
        </p>
        <p className="text-sm">
          <a href="tel:0939035444" className="text-white font-medium hover:underline">
            09 39 03 54 44
          </a>
        </p>

        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm pt-4 border-t border-gray-700">
          <Link to="/" className="hover:text-white hover:underline">
            Site principal
          </Link>
          <Link to="/mentions-legales" className="hover:text-white hover:underline">
            Mentions légales
          </Link>
          <Link to="/politique-confidentialite" className="hover:text-white hover:underline">
            Politique de confidentialité
          </Link>
          <button
            type="button"
            onClick={ouvrirPreferences}
            className="hover:text-white hover:underline"
          >
            Préférences cookies
          </button>
        </nav>

        <p className="text-xs text-gray-400 pt-2">
          MaPrimeAdapt&apos; est un dispositif de l&apos;Agence nationale de l&apos;habitat.
          Transition Énergie France n&apos;est pas un service de l&apos;État.
        </p>
      </div>
    </div>
  </footer>
);

export default PiedLanding;
